import React from 'react';
import { NavLink } from 'react-router-dom';

const completedProjects = [
  {
    image: require('./../../images/projects/portrait/pic1.jpg'),
    title: "Brigade Tech Boulevard Tower – Pallavaram, Chennai",
    description: "Fire Protection System installation ensuring compliance and safety for a commercial tower development.",
    filter: "cat-2"
  },
  {
    image: require('./../../images/projects/portrait/pic2.jpg'),
    title: "NCC Urban Signature Towers – Sholinganallur, Chennai",
    description: "Fire Protection System installation for the club house facility within the NCC Urban Signature Towers development.",
    filter: "cat-2"
  },
  {
    image: require('./../../images/projects/portrait/pic3.jpg'),
    title: "NCC Urban Signature Towers – Fire Pump Room & FAPA (Phase I), Sholinganallur, Chennai",
    description: "Fire Protection System covering Fire Pump Room and Fire Alarm & Public Address (FAPA) systems as part of Phase I execution.",
    filter: "cat-2"
  },
  {
    image: require('./../../images/projects/portrait/pic4.jpg'),
    title: "Foxconn A31 Building – Devanahalli, Bengaluru",
    description: "Fire Protection System installation across a 3-floor industrial building ensuring robust safety infrastructure.",
    filter: "cat-2"
  },
  {
    image: require('./../../images/projects/portrait/pic5.jpg'),
    title: "Bhaggayam Pranathi Luxury Apartments – Cenotaph Road, Chennai",
    description: "Fire Protection System, FAPA and signage works completed for a luxury residential apartment complex.",
    filter: "cat-2"
  },
  {
    image: require('./../../images/projects/portrait/pic3.jpg'),
    title: "DP World Warehouse Project, Kambalipura, Bengaluru",
    description: "Design and execution of Fire Protection Systems for an international logistics and warehousing facility adhering to NFPA standards.",
    filter: "cat-1"
  }
];

const ongoingProjects = [
  {
    image: require('./../../images/projects/portrait/pic6.jpg'),
    title: "PSG Multi Specialty Hospital – Coimbatore",
    description: "HVAC System design, supply, installation, testing and commissioning as part of ongoing renovation works.",
    filter: "cat-2"
  },
  {
    image: require('./../../images/projects/portrait/pic7.jpg'),
    title: "PSG ITECH Hostel – Coimbatore",
    description: "Kitchen Exhaust System installation ensuring efficient ventilation for the hostel facility.",
    filter: "cat-2"
  },
  {
    image: require('./../../images/projects/portrait/pic8.jpg'),
    title: "NCC Urban Signature Towers – Phase II, Sholinganallur, Chennai",
    description: "Fire Protection System installation currently underway as part of the Phase II development works.",
    filter: "cat-2"
  },
  {
    image: require('./../../images/projects/portrait/pic9.jpg'),
    title: "NCC Urban Ivy Towers, Pallavaram, Chennai",
    description: "Fire Protection System installation in progress for the residential Ivy Towers development.",
    filter: "cat-2"
  },
  {
    image: require('./../../images/projects/portrait/pic10.jpg'),
    title: "Atulit Business Center – Bedford, Coonoor",
    description: "HVAC System design, supply, installation, testing and commissioning currently in progress.",
    filter: "cat-2"
  },
  {
    image: require('./../../images/projects/portrait/pic5.jpg'),
    title: "Nala Hotels, Namakkal",
    description: "Turnkey Fire Protection System for a hospitality infrastructure project ensuring guest safety and operational reliability.",
    filter: "cat-2"
  },
];

class OurProject4 extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };
    render() {
        return (
            <>
                <div className="section-full p-t80 p-b50 bg-gray mobile-page-padding">

                     <div className="container">
                            {/* TITLE START */}
                            <div className="section-head">
                                <div className="mt-separator-outer separator-center">
                                    <div className="mt-separator">
                                        <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Ongoing</span> Projects</h2>
                                    </div>
                                </div>
                            </div>
                            {/* TITLE END */}
                            {/* PAGINATION START */}
                            {/* <div className="filter-wrap p-b30 text-center">
                                <ul className="filter-navigation inline-navigation masonry-filter link-style  text-uppercase">
                                <li className="active"><NavLink to={"#"} data-filter="*" data-hover="All">All</NavLink></li>
                                {filters.map((item, index) => (
                                    <li key={index}><NavLink to={"#"} data-filter={item.filter} data-hover={item.label}>{item.label}</NavLink></li>
                                ))}
                                </ul>
                            </div> */}
                            {/* PAGINATION END */}
                            {/* GALLERY CONTENT START */}
                            <div className="portfolio-wrap mfp-gallery work-grid row clearfix">
                                {ongoingProjects.map((item, index) => (
                                    <div key={index} className={`${item.filter} masonry-item col-md-4 col-sm-6 m-b30`}>
                                        <div className="image-effect-inverse hover-shadow">
                                            <div className="figcaption">
                                                <h4 className="mt-tilte">{item.title}</h4>
                                                <p className="font-weight-600">{item.address}</p>
                                                <p>{item.description}</p>
                                                {/* <NavLink to="/project-detail" className="read-more site-button btn-effect">Read More</NavLink> */}
                                                {/* <a className="mfp-link" href={item.image2}>
                                                    <i className="fa fa-arrows-alt" />
                                                </a> */}
                                            </div>
                                            <img src={item.image} alt="" />
                                        </div>

                                    </div>
                                ))}
                            </div>
                            {/* GALLERY CONTENT END */}
                            {/* <div className="m-t50 text-center">
                                <NavLink to={"#"} className="site-button btn-effect">Load More</NavLink>
                            </div> */}
                        </div>

                        <br /><br />

                        <div className="container">
                            {/* TITLE START */}
                            <div className="section-head">
                                <div className="mt-separator-outer separator-center">
                                    <div className="mt-separator">
                                        <h2 className="text-uppercase sep-line-one "><span className="font-weight-300 text-primary">Completed</span> Projects</h2>
                                    </div>
                                </div>
                            </div>
                            {/* TITLE END */}
                            {/* PAGINATION START */}
                            {/* <div className="filter-wrap p-b30 text-center">
                                <ul className="filter-navigation inline-navigation masonry-filter link-style  text-uppercase">
                                <li className="active"><NavLink to={"#"} data-filter="*" data-hover="All">All</NavLink></li>
                                {filters.map((item, index) => (
                                    <li key={index}><NavLink to={"#"} data-filter={item.filter} data-hover={item.label}>{item.label}</NavLink></li>
                                ))}
                                </ul>
                            </div> */}
                            {/* PAGINATION END */}
                            {/* GALLERY CONTENT START */}
                            <div className="portfolio-wrap mfp-gallery work-grid row clearfix">
                                {completedProjects.map((item, index) => (
                                    <div key={index} className={`${item.filter} masonry-item col-md-4 col-sm-6 m-b30`}>
                                        <div className="image-effect-inverse hover-shadow">
                                            <div className="figcaption">
                                                <h4 className="mt-tilte">{item.title}</h4>
                                                <p className="font-weight-600">{item.address}</p>
                                                <p>{item.description}</p>
                                                {/* <NavLink to="/project-detail" className="read-more site-button btn-effect">Read More</NavLink> */}
                                                {/* <a className="mfp-link" href={item.image2}>
                                                    <i className="fa fa-arrows-alt" />
                                                </a> */}
                                            </div>
                                            <img src={item.image} alt="" />
                                        </div>

                                    </div>
                                ))}
                            </div>
                            {/* GALLERY CONTENT END */}
                            {/* <div className="m-t50 text-center">
                                <NavLink to={"#"} className="site-button btn-effect">Load More</NavLink>
                            </div> */}
                        </div>

                    </div>    
            </>
        );
    }
};

export default OurProject4;